import { render, staticRenderFns } from "./ProjectTemplateDownloadPage.vue?vue&type=template&id=2907ad5c"
import script from "./ProjectTemplateDownloadPage.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplateDownloadPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports